import { useCallback } from "react";
import Api from "../../../utills/api.utills";
// import { useSelector } from "react-redux";
// import { getTokenId } from "../../selectors/appState.selector";

function useApi() {
  const tokenId =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMTg2NzM0NzUtQjcwMi00MUM2LUEzRDItNzU5NDlFOUQxNTA3IiwiZGJfbmFtZSI6IlBBXzAwMDA3IiwiaWF0IjoxNzQ2NjkzNjYxLCJleHAiOjE3NzgyMjk2NjF9.oDUgjYqEcnxt4ykg14N26KArun9hpNFGxfc1KVolyhg";
  const apiPost = useCallback(
    async (config) => {
      config = { ...config, header: `Bearer ` + tokenId };
      let mResponse = [];
      try {
        mResponse = await Api.post({
          ...config,
        });
      } catch (err) {
        console.log("Post Error :- " + err);
      } finally {
        return mResponse;
      }
    },
    [tokenId]
  );

  return {
    apiPost,
  };
}
export default useApi;
